import React, {useContext, useEffect} from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import './Redirect.scss'
import success from '../../success.gif'
import AuthContext from "../../Store/auth-context";

function Success() {
    const { setRoleStatus, setTime ,login} = useContext(AuthContext);

    useEffect(()=>{
        function fetchData(){
            try {
                    fetch('https://stripe-node-vx6pg.ondigitalocean.app/updateRole',{
                    // fetch('http://aad3-66-154-104-9.ngrok.io/updateRole',{
                    crossDomain:true,
                    method:'POST',
                    headers: {'Content-Type':'application/json','Accept': 'application/json'},
                })
                    .then(function(res){return res.json()})
                    .then(function(response){
                        if(response.data !==[] && response.data[0] !== undefined ){
                            setRoleStatus(response.data[0].is_active);
                            setTime(response.data[0].current_period_end);
                            if(response.data[0].is_active){
                                login("loggedin");
                            }
                        }
                    });
            } catch (e) {
                console.log(e.message);
            }
        }
        fetchData();

    })
    return (
        <div id='redirectMessage'>
            <div className='messageContainer'>
                <img className='responseLogo' src={success} alt="success" />
                <h1 className='responseHeader'>This transaction has been successful!</h1>
                <p className='responseText'>Welcome to capncovers! Visit our dashboard <a href="https://capncovers.com/dashboard">here</a>.</p>
            </div>
        </div>
    )
}

export default Success
